import { Component, Inject, Optional, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgIf } from '@angular/common';
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IBooking } from './model';


@Component({
  selector: 'app-viewimage',
  standalone: true,
  imports: [NgIf, FontAwesomeModule],
  templateUrl: './viewimage.component.html',
  styleUrl: './viewimage.component.css'
})
export class ViewimageComponent {
  faTimes = faTimes;
  faEdit = faEdit;
  constructor(private sanitizer: DomSanitizer, public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<ViewimageComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: IBooking) {
    this.imageAttachment.set(dialogData.attachment);
    this.bookingId.set(dialogData.bookingId);
  }

  imageAttachment = signal('');
  bookingId = signal('');
  getSafeUrl(imageUrl: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);
  }
}
